var _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _path5, _path6, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadNewApp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 400,
    viewBox: "0 0 266 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 133,
    cy: 185.683,
    r: 132.5,
    fill: "#F5F5F5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 179.306,
    cy: 319.1,
    r: 80.692,
    fill: "#F5F5F5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 213.234,
    cy: 33.9273,
    r: 33.9273,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.86 140.131L210.915 154.347C214.372 154.946 216.539 158.539 215.623 162.464L173.597 342.564C172.681 346.489 169.071 349.082 165.614 348.483L83.5587 334.267C80.1015 333.668 77.9347 330.075 78.8506 326.15L120.876 146.05C121.792 142.124 125.402 139.532 128.86 140.131Z",
    fill: "#D9D9D9",
    stroke: "#262626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M211.028 153.861L128.973 139.645C125.197 138.991 121.351 141.82 120.384 145.964L78.3584 326.065C77.3913 330.209 79.6688 334.099 83.4453 334.753L165.501 348.969C169.277 349.623 173.123 346.794 174.09 342.649L216.115 162.549C217.082 158.405 214.805 154.515 211.028 153.861Z",
    stroke: "#262626",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M204.611 183.604L121.708 169.324L89.8626 305.01L172.766 319.29L204.611 183.604Z",
    fill: "white",
    stroke: "#262626",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M129.189 332.741C133.069 333.406 137.02 330.532 138.013 326.323C139.007 322.115 136.667 318.164 132.787 317.5C128.907 316.835 124.957 319.708 123.963 323.917C122.97 328.126 125.31 332.077 129.189 332.741Z",
    stroke: "#262626",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M156.139 162.016L170.832 164.971",
    stroke: "#262626",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5993 120.256L27.2262 124.773C23.1766 125.087 20.2173 128.582 20.5308 132.632L23.8826 176.414C24.196 180.464 27.6943 183.46 31.7439 183.146L90.117 178.629C94.1666 178.315 97.1623 174.817 96.8489 170.767L93.4606 126.987C93.1472 122.938 89.6489 119.942 85.5993 120.256ZM46.7496 163.634L42.3716 163.973L32.0801 151.924L33.0684 164.693L28.508 165.046L26.8138 143.156L31.3742 142.803L41.4833 154.866L40.495 142.097L45.0554 141.744L46.7496 163.634ZM63.6528 144.929L54.532 145.635L54.8482 149.721L63.969 149.015L64.3248 153.612L55.204 154.318L55.5174 158.368L64.6382 157.662L64.9911 162.222L50.3979 163.352L48.7037 141.462L63.297 140.332L63.6528 144.929ZM90.247 156.598C90.4023 158.604 88.8876 160.373 86.881 160.528L72.2878 161.658C70.2812 161.813 68.5124 160.298 68.3571 158.292L66.9453 140.05L71.5057 139.697L72.7791 156.151L76.9017 155.832L75.9078 142.99L80.4682 142.637L81.4593 155.443L85.5454 155.126L84.2748 138.709L88.8352 138.356L90.247 156.598Z",
    fill: "#757575"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7320_14122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.243 357.621L242.639 350.319L245.459 342.688L238.25 338.888L236.043 331.049L227.981 332.216L221.583 327.175L215.753 332.86L207.615 332.525L206.241 340.544L199.463 345.086L203.068 352.388L200.242 360.04L207.451 363.841L209.658 371.679L217.726 370.491L224.123 375.532L229.954 369.847L238.097 370.161L239.471 362.142L246.243 357.621ZM222.131 362.555L217.878 361.416L219.018 357.163L223.271 358.302L222.131 362.555ZM224.41 354.05L220.157 352.91L223.576 340.152L227.829 341.291L224.41 354.05Z",
    fill: "#757575"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7320_14122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.833,
    height: 52.833,
    fill: "white",
    transform: "translate(204.174 319) rotate(15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadNewApp);
export default __webpack_public_path__ + "static/media/download-new-app.d8211ce226ffaa46d79d0d7a64193b70.svg";
export { ForwardRef as ReactComponent };